/**
 * Paidy Widget Price Update
 * バリアント変更時にPaidyウィジェットの金額を更新
 */

if (typeof PUB_SUB_EVENTS !== 'undefined') {
  // バリアント変更イベントをリスニング
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const { variant } = event.data;
    
    if (!variant) return;
    
    // Paidyウィジェットを取得
    const paidyWidget = document.querySelector('._paidy-promotional-messaging');
    
    if (!paidyWidget) return;
    
    // 新しい価格を取得（セント単位）
    const newPrice = variant.price;
    
    // 価格を日本円形式に変換（例: 10000 → ¥10,000）
    const formattedPrice = `¥${(newPrice / 100).toLocaleString('ja-JP')}`;
    
    // data-amount属性を更新
    paidyWidget.setAttribute('data-amount', formattedPrice);
    
    // Paidyウィジェットをリフレッシュ
    if (typeof _paidy !== 'undefined') {
      _paidy('pm:refresh');
    }
  });
}
